// iOS's edge swipe-back over the web view (ART-268), through the wrapper's in-app `BackSwipe` plugin
// (BackSwipePlugin.swift). The gesture steps back through the web view's HISTORY, so the app turns it on only while
// a drilled-in screen shows a back chevron — whose handler is itself a history-back — and off on tab roots.
import { Capacitor, registerPlugin } from "@capacitor/core";

interface BackSwipePlugin {
  setEnabled(options: { enabled: boolean }): Promise<void>;
}

const BackSwipe = registerPlugin<BackSwipePlugin>("BackSwipe");

let current: boolean | null = null;

/**
 * Turn the native swipe-back on or off. A no-op on the web and Android (mobile Safari has its own edge swipe), and
 * when nothing changed. A wrapper too old to carry the plugin rejects, which is swallowed: the swipe simply stays
 * off, exactly as before the plugin existed.
 */
export function setBackSwipeEnabled(enabled: boolean): void {
  if (!Capacitor.isNativePlatform() || Capacitor.getPlatform() !== "ios") return;
  if (current === enabled) return;
  current = enabled;
  BackSwipe.setEnabled({ enabled }).catch(() => {});
}

/** Test hook: forget the last value sent. */
export function _resetBackSwipeForTest(): void {
  current = null;
}
